var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.unitWaitingPage},[_c('LoadingAnimate',{attrs:{"tips-text":"正在为您匹配资方"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }